import { z } from 'zod';

import { isNumber } from '../../../utils/common.util';

export const MinValueValidationBlockSchema = z.number();
export type MinValueValidationBlock = z.infer<
  typeof MinValueValidationBlockSchema
>;

type IsMinValue = (value: unknown, block: MinValueValidationBlock) => boolean;
export const isMinValue: IsMinValue = (value, block) => {
  if (!isNumber(value)) {
    return false;
  }

  return value >= block;
};
